import { render } from "./ApplicationLogo.vue?vue&type=template&id=b822856e"
const script = {}

import exportComponent from "/var/www/vhosts/packperform.com/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__